export default {
  EAT_LAMBO: 'lambo',
  EAT_CRATE: 'crate',
  EAT_FLAG: 'flag',
}
